/* A wireframe status pill. @/ui’s Pill gained a `mark` prop on 31/08 (the gap
   this file was opened for), so this is now a thin adapter over it: `mark: ''`
   gives the mark-only pills WF-15 draws (— · ✓ · ◔ · ●), an absent mark keeps
   the tone’s default glyph. Kept as one import site for the AD frames. */
import { Pill } from '@/ui'
import type { StatusCell } from './api'

export default function Mark({ cell }: { cell: StatusCell }) {
  return <Pill tone={cell.tone} mark={cell.mark}>{cell.label}</Pill>
}
